import { Box, HBox } from "@ui/box/Box";
import { CountryFlag } from "./CountryFlag";
import { Typo } from "@ui/text/Typo";
import { CountriesData } from "@ui/utils/CountriesData";

export interface ICountryClipProps {
	code: string;
	showName?: boolean;
}

export const CountryClip = ({ code, showName }: ICountryClipProps) => {
	return (
		<HBox gap="6px" sx={{ alignItems: "center", flexShrink: "0" }}>
			<Box>
				<CountryFlag code={code} />
			</Box>
			<Typo sx={{ display: "flex", flexShrink: "0", width: "min-content" }} variant="medium">
				{showName ? CountriesData.countries.find(country => country.alpha2 === code)?.name : code}
			</Typo>
		</HBox>
	);
};
